<div class="header_wrap">
  <div class="header sales-header">
    <div class="header-bg"></div>
    <div class="header-content">
      <div class="header-content-left flex-align-center">
        <div class="header-content-left-logo">
        </div>
        <div class="header-content-left-line">
        </div>
        <div class="header-content-left-title">Sales Portal</div>
      </div>
      <div class="header-content-right flex">
        <span class="header-content-right-lang">EN</span>
        <i class="header-content-right-line"></i>
        <span class="header-content-right-language cursor-pointer">Sign in</span>
        <i class="header-content-right-user"></i>
        <svg-icon class="header-content-right-icon" [size]="24" [iconName]="'login.svg'"></svg-icon>
      </div>
    </div>
  </div>
</div>



